// extracted by css-extract-rspack-plugin
export default {"wrapper":"Z77Wj","icon":"b9A_G","input":"Gn9nF"};